module.exports = __webpack_public_path__ + "img/bakery_demo-400x300.0e84eb0f.jpg";